import React from 'react';

const Footer = ({ footerData, theme }) => {
  const { logo, description, socialLinks, examLinks, footerLinks, copyright, examLinksTitle } = footerData;

  const styles = {
        footer: {
          background: `linear-gradient(135deg, ${theme?.primary?.blue?.[500]} 0%, ${theme?.primary?.blue?.[500]} 100%)`,
         paddingTop: '15px',
         paddingBottom: '15px',
         position: 'relative'
       
      },
    footerContainer: {
      
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 2rem'
    },
    footerContent: {
      display: 'grid',
      gridTemplateColumns: '1fr',
      gap: '3rem',
      marginBottom: '3rem'
    },
    footerBrand: {
      display: 'flex',
      flexDirection: 'column',
      gap: '1.5rem'
    },
    logoContainer: {
      background: theme?.neutral?.white,
      borderRadius: '12px',
      padding: '1rem 1.5rem',
      display: 'inline-flex',
      alignItems: 'center',
      width: 'fit-content',
      boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
    },
    logo: {
      height: '32px',
      width: 'auto'
    },
    footerDescription: {
      fontSize: '1rem',
      lineHeight: '1.6',
      color: theme?.neutral?.white,
      maxWidth: '320px'
    },
    socialLinks: {
      display: 'flex',
      gap: '1rem',
      alignItems: 'center'
    },
    socialLink: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '44px',
      height: '44px',
      background: 'rgba(255, 255, 255, 0.1)',
      borderRadius: '8px',
      color: theme?.neutral?.white,
      textDecoration: 'none',
      transition: 'all 0.3s ease',
      border: '1px solid rgba(255, 255, 255, 0.1)'
    },
    socialIcon: {
      width: '20px',
      height: '20px',
      objectFit: 'contain'
    },
    socialLinkHover: {
      background: 'rgba(255, 255, 255, 0.2)',
      transform: 'translateY(-2px)',
      boxShadow: '0 8px 25px rgba(0,0,0,0.15)',
      borderColor: 'rgba(255, 255, 255, 0.3)'
    },
    sectionHeader: {
      fontSize: '1.125rem',
      fontWeight: '700',
      color: theme?.text?.primary,
      marginBottom: '1.5rem',
      letterSpacing: '0.025em'
    },
    certificationsGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 260px), 1fr))',
      gap: '0.75rem'
    },
    certificationItem: {
      
      borderRadius: '8px',
      padding: '0.75rem',
      display: 'flex',
      alignItems: 'center',
      gap: '0.75rem',
      transition: 'all 0.3s ease',
      cursor: 'pointer',
      textDecoration: 'none',
      color: 'inherit'
    },
    certificationIcon: {
      width: '32px',
      height: '32px',
      borderRadius: '6px',
      objectFit: 'cover'
    },
    certificationContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: '0.25rem'
    },
    certificationName: {
      fontSize: '0.875rem',
      fontWeight: '600',
      color: theme?.text?.primary
    },
    certificationDetails: {
      fontSize: '0.75rem',
      color: theme?.neutral?.white
    },
    certificationItemHover: {
      background: 'rgba(255, 255, 255, 0.1)',
      transform: 'translateY(-1px)',
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
      borderColor: 'rgba(255, 255, 255, 0.2)'
    },
    linkColumn: {
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem'
    },
    linkList: {
      listStyle: 'none',
      padding: 0,
      margin: 0,
      display: 'flex',
      flexDirection: 'column',
      gap: '0.75rem'
    },
    link: {
      fontSize: '0.875rem',
      color: theme?.text?.primary,
      textDecoration: 'none',
      transition: 'all 0.3s ease',
      padding: '0.5rem 0',
      display: 'block'
    },
    linkHover: {
      color: theme?.neutral?.white,
      transform: 'translateX(4px)'
    },
    bottomSection: {
      borderTop: '1px solid rgba(255, 255, 255, 0.1)',
      paddingTop: '1.5rem',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      gap: '1rem'
    },
    copyrightText: {
      fontSize: 'clamp(0.75rem, 2vw, 0.875rem)',
      color: theme?.text?.secondary
    },
    footerLinksBottom: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      gap: '1rem'
    },
    bottomLink: {
      fontSize: '0.875rem',
      color: theme?.text?.secondary,
      textDecoration: 'none',
      transition: 'color 0.3s ease'
    },
    bottomLinkHover: {
      color: theme?.neutral?.white
    }
  };

  return (
    <footer style={styles.footer}>
      <div style={styles.footerContainer}>
        <div style={styles.footerContent}>
          {/* Certifications Section */}
          <div style={{ textAlign: 'left' }}>
            <h3 style={styles.sectionHeader}>{examLinksTitle}</h3>
            <div style={styles.certificationsGrid}>
              {examLinks.map((exam, index) => (
                <a
                  key={index}
                  href={exam.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={styles.certificationItem}
                  
                >
                  <img src={exam.icon} alt={exam.name} style={styles.certificationIcon} />
                  <div style={styles.certificationContent}>
                    <span style={styles.certificationName}>{exam.name}</span>
                    <span style={styles.certificationDetails}>{exam.details}</span>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div style={styles.bottomSection} className="footer-bottom">
          <p style={styles.copyrightText}>{copyright}</p>
          <div style={styles.footerLinksBottom}>
            {footerLinks.map((link, linkIndex) => (
              <a
                key={linkIndex}
                href={link.url}
                style={styles.bottomLink}
                onMouseEnter={(e) => e.target.style.color = styles.bottomLinkHover.color}
                onMouseLeave={(e) => e.target.style.color = styles.bottomLink.color}
              >
                {link.name}
              </a>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @media (min-width: 640px) {
          .footer-bottom {
            flex-direction: row !important;
            justify-content: space-between !important;
            text-align: left !important;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;